import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function getProduct() {
    return request({
        url: '/web/order/get_product',
        method: 'post',
        data: {
            session_key: getToken(),
            area: localStorage.getItem("area")
        }
    })
}

export function getCouponList() {
    return request({
        url: '/web/order/get_coupon_list',
        method: 'post',
        data: {
            session_key: getToken()
        }
    })
}

export function createOrder(product_id,coupon_id,pay_type,exam_year) {
    return request({
        url: '/web/order/create',
        method: 'post',
        data: {
            session_key: getToken(),
            product_id: product_id,
            coupon_id: coupon_id,
            pay_type: pay_type,
            exam_year: exam_year
        }
    })
}

export function isPay(order_no) {
    return request({
        url: '/web/order/is_pay',
        method: 'post',
        data: {
            session_key: getToken(),
            order_no: order_no,
        }
    })
}

export function againPay(order_no) {
    return request({
        url: '/web/order/pay',
        method: 'post',
        data: {
            session_key: getToken(),
            order_no: order_no,
        }
    })
}

export function orderDetail(order_no) {
    return request({
        url: '/web/order/detail',
        method: 'post',
        data: {
            session_key: getToken(),
            order_no: order_no,
        }
    })
}

export function orderList() {
    return request({
        url: '/web/order/lst',
        method: 'post',
        data: {
            session_key: getToken(),
        }
    })
}